import React, { useState, useMemo, useEffect } from "react";
import { Space, DatePicker, TimePicker, Dropdown } from "antd";
import { DeleteFilled, PlusOutlined, DownOutlined } from "@ant-design/icons";
import Comp from "./comp";
import dayjs from "dayjs";

import "@/plugins/desc.less";
import {
  Input,
  Slider,
  ConfigTitle,
  Select,
  BaseButton,
  Radio,
} from "@/components";
import { InputNumber3x, Slider3x, InputWithImg, HotArea } from "@/HOC";
import _ from "lodash";

const Selector = ({
  content = () => {},
  list = [],
  onClickDelete = () => {},
  onClickAdd = () => {},
  deleteButtonText = "删除本组",
  addFrameText = "添加帧数",
  selectTitles = [],
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const realIndex = list.length === 0 ? 0 : selectedIndex % list.length;
  useEffect(() => {
    setSelectedIndex(realIndex);
  }, [list]);
  return (
    <Space direction="vertical" size={10} align="start">
      <Select
        chooseList={list.map((_, i) => selectTitles[i] || `第${i + 1}组`)}
        onClick={(idx) => {
          setSelectedIndex(idx);
        }}
        currentIndex={realIndex}
      ></Select>
      {content(list[realIndex], realIndex)}
      <Space>
        <BaseButton
          style={{
            width: 155,
          }}
          type="normal"
          icon={<DeleteFilled />}
          content={deleteButtonText}
          onClick={() => {
            onClickDelete(selectedIndex);
          }}
        />
        <BaseButton
          style={{
            width: 155,
          }}
          type="normal"
          icon={<PlusOutlined />}
          content={addFrameText}
          onClick={() => {
            onClickAdd();
          }}
        />
      </Space>
    </Space>
  );
};

export default function Desc({
  currentPlugin,
  changeCurrentPluginRect,
  updateCurrentPluginProps,
}) {
  const { props, rectOptions, extension } = currentPlugin;
  const {
    banners,
    singleImageWidth,
    singleImageHeight,
    between,
    fallbackImage,
    liveCoverImage,
    newSkuCoverImage,
    activityCoverImage,
  } = props;
  const { width, left, top } = rectOptions;
  const dropdownList = useMemo(() => {
    return banners.map((item, index) => {
      return {
        label: `第${index + 1}组`,
        key: index,
      };
    });
  }, [banners]);

  return (
    <div className="desc-wrap">
      <ConfigTitle
        style={{
          padding: "20px 0 5px 20px",
        }}
        title="日期配置"
        detail="待输入"
      />
      <div className="desc-board">
        <Space direction="vertical" size={10} align="start">
          <ConfigTitle
            title="待输入"
            detail="待输入"
            style={{
              height: 37,
            }}
            titleSize={14}
            detailSize={12}
          />
          <Selector
            list={banners}
            deleteButtonText="删除日期"
            addFrameText="添加日期"
            onClickAdd={() => {
              const newBanners = [...props.banners];
              newBanners.push(Object.assign({}, extension.struct));
              updateCurrentPluginProps({
                banners: newBanners,
              });
            }}
            onClickDelete={(deleteIndex) => {
              if (banners.length === 1) {
                return;
              }
              const newBanners = _.cloneDeep(banners);
              newBanners.splice(deleteIndex, 1);
              updateCurrentPluginProps({
                banners: newBanners,
              });
            }}
            content={(currentBanner, dateSelectorIndex) => {
              return (
                <Space direction="vertical" size={10} align="start">
                  <Dropdown
                    menu={{
                      items: dropdownList,
                      onClick: ({ key }) => {
                        // setSelectedIndex(idx);
                        const newBanners = _.cloneDeep(banners);
                        const copyBanner = _.cloneDeep(newBanners[key]);
                        copyBanner.date = currentBanner.date;
                        newBanners[dateSelectorIndex] = copyBanner;
                        updateCurrentPluginProps({
                          banners: newBanners,
                        });
                      },
                    }}
                    onOpenChange={(e) => {}}
                    style={{
                      maxHeight: 500,
                      width: 1000,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          width: 112,
                          overflow: "hidden",
                          userSelect: "none",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        要复制第几组
                      </div>
                      <DownOutlined style={{ color: "black", fontSize: 10 }} />
                    </div>
                  </Dropdown>
                  <DatePicker
                    value={
                      currentBanner.date
                        ? dayjs(currentBanner.date)
                        : dayjs(new Date())
                    }
                    onChange={(val) => {
                      const newBanners = _.cloneDeep(banners);
                      newBanners[dateSelectorIndex].date =
                        val.format("YYYY/MM/DD");
                      updateCurrentPluginProps({
                        banners: newBanners,
                      });
                    }}
                  />
                  <Input
                    labelContent="活动日名称"
                    defaultValue={currentBanner.activityName}
                    onChange={(e) => {
                      const newBanners = _.cloneDeep(banners);
                      newBanners[dateSelectorIndex].activityName = e;
                      updateCurrentPluginProps({
                        banners: newBanners,
                      });
                    }}
                  />
                  <ConfigTitle
                    title="活动类型"
                    detail="当前日期下的所有活动类型"
                    style={{
                      height: 37,
                    }}
                    titleSize={14}
                    detailSize={12}
                  />
                  <Selector
                    deleteButtonText="删除活动类型"
                    addFrameText="添加活动类型"
                    list={currentBanner.activityGroup}
                    onClickDelete={(deleteIndex) => {
                      const newBanners = _.cloneDeep(banners);
                      newBanners[dateSelectorIndex].activityGroup.splice(
                        deleteIndex,
                        1,
                      );
                      updateCurrentPluginProps({
                        banners: newBanners,
                      });
                    }}
                    onClickAdd={() => {
                      const newBanners = _.cloneDeep(banners);
                      newBanners[dateSelectorIndex].activityGroup.push(
                        extension.struct.activityGroup[0],
                      );
                      updateCurrentPluginProps({
                        banners: newBanners,
                      });
                    }}
                    selectTitles={["新品闪购", "热卖直播", "热门活动"]}
                    content={(currentActivityGroup, activityGroupIndex) => {
                      return (
                        <>
                          <ConfigTitle
                            title="活动"
                            detail="配置当前活动类型下的活动"
                            style={{
                              height: 37,
                            }}
                            titleSize={14}
                            detailSize={12}
                          />
                          <Selector
                            deleteButtonText="删除活动"
                            addFrameText="添加活动"
                            list={currentActivityGroup}
                            onClickDelete={(deleteIndex) => {
                              const newBanners = _.cloneDeep(banners);
                              newBanners[dateSelectorIndex].activityGroup[
                                activityGroupIndex
                              ].splice(deleteIndex, 1);
                              updateCurrentPluginProps({
                                banners: newBanners,
                              });
                            }}
                            onClickAdd={() => {
                              const newBanners = _.cloneDeep(banners);
                              newBanners[dateSelectorIndex].activityGroup[
                                activityGroupIndex
                              ].push(extension.struct.activityGroup[0][0]);
                              updateCurrentPluginProps({
                                banners: newBanners,
                              });
                            }}
                            content={(activity, activityIndex) => {
                              return (
                                currentActivityGroup.length > 0 && (
                                  <Space
                                    direction="vertical"
                                    size={10}
                                    align="start"
                                  >
                                    <TimePicker
                                      value={
                                        activity.time
                                          ? dayjs(
                                              `${currentBanner.date} ${activity.time}`,
                                            )
                                          : dayjs(
                                              dayjs(
                                                `${currentBanner.date} 00:00:00`,
                                              ),
                                            )
                                      }
                                      onChange={(val) => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].time = val.format("HH:mm:ss");
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                    />
                                    <InputWithImg
                                      labelContent="图片链接"
                                      defaultValue={activity.imageUrl}
                                      onChange={(e) => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].imageUrl = e;
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                    />
                                    <Input
                                      labelContent="跳转链接"
                                      defaultValue={activity.jumpUrl}
                                      onChange={(e) => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].jumpUrl = e;
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                    />
                                    <Input
                                      labelContent="活动ID(唯一)"
                                      defaultValue={activity.activity_id}
                                      onChange={(e) => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].activity_id = e;
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                    />
                                    <Input
                                      labelContent="预约标题"
                                      defaultValue={activity.title}
                                      onChange={(e) => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].title = e;
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                    />
                                    <Input
                                      labelContent="预约描述"
                                      defaultValue={activity.message}
                                      onChange={(e) => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].message = e;
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                    />
                                    <HotArea
                                      editContentSize={{
                                        width: singleImageWidth,
                                        height: singleImageHeight,
                                      }}
                                      contentFit="fill"
                                      defaultValue={activity.hotArea}
                                      editContent={activity.imageUrl}
                                      onSave={(data) => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].hotArea = data;
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                      showCopyBtn={activityIndex !== 0}
                                      onCopy={() => {
                                        const newBanners = _.cloneDeep(banners);
                                        newBanners[
                                          dateSelectorIndex
                                        ].activityGroup[activityGroupIndex][
                                          activityIndex
                                        ].hotArea =
                                          newBanners[
                                            dateSelectorIndex
                                          ].activityGroup[
                                            activityGroupIndex
                                          ][0].hotArea;
                                        updateCurrentPluginProps({
                                          banners: newBanners,
                                        });
                                      }}
                                    />
                                  </Space>
                                )
                              );
                            }}
                          ></Selector>
                        </>
                      );
                    }}
                  ></Selector>
                </Space>
              );
            }}
          ></Selector>
          <InputWithImg
            labelContent="兜底图链接"
            defaultValue={fallbackImage}
            onChange={(e) => {
              updateCurrentPluginProps({
                fallbackImage: e,
              });
            }}
          />
          <InputWithImg
            labelContent="新品遮罩图链接"
            defaultValue={newSkuCoverImage}
            onChange={(e) => {
              updateCurrentPluginProps({
                newSkuCoverImage: e,
              });
            }}
          />
          <InputWithImg
            labelContent="直播遮罩图链接"
            defaultValue={liveCoverImage}
            onChange={(e) => {
              updateCurrentPluginProps({
                liveCoverImage: e,
              });
            }}
          />
          <InputWithImg
            labelContent="活动遮罩图链接"
            defaultValue={activityCoverImage}
            onChange={(e) => {
              updateCurrentPluginProps({
                activityCoverImage: e,
              });
            }}
          />
        </Space>
      </div>
      <div className="desc-board">
        <Space direction="vertical" align="start" size={10}>
          <ConfigTitle
            title="单张图片尺寸"
            detail="尺寸"
            style={{
              height: 37,
            }}
            titleSize={14}
            detailSize={12}
          />
          <Space size={10}>
            <InputNumber3x
              labelContent="宽"
              defaultValue={singleImageWidth}
              onChange={(e) => {
                updateCurrentPluginProps({
                  singleImageWidth: e,
                });
              }}
            />
            <InputNumber3x
              labelContent="高"
              defaultValue={singleImageHeight}
              onChange={(e) => {
                updateCurrentPluginProps({
                  singleImageHeight: e,
                });
                changeCurrentPluginRect({
                  height: e,
                });
              }}
            />
          </Space>
          <Space size={10}>
            <InputNumber3x
              labelContent="上边距"
              defaultValue={top}
              onChange={(e) => {
                changeCurrentPluginRect(
                  {
                    top: e,
                  },
                  activeIndex + 1,
                );
              }}
            />
            <InputNumber3x
              labelContent="左边距"
              defaultValue={left}
              onChange={(e) => {
                changeCurrentPluginRect(
                  {
                    left: e,
                  },
                  activeIndex + 1,
                );
              }}
            />
          </Space>
          <InputNumber3x
            labelContent="间距"
            defaultValue={between}
            onChange={(e) => {
              updateCurrentPluginProps({
                between: e,
              });
            }}
          />
          <Slider3x
            title="滑动宽度"
            min={extension.scrollWidthDuration[0]}
            max={extension.scrollWidthDuration[1]}
            defaultValue={width}
            suffix="px"
            onChange={(v) => {
              changeCurrentPluginRect({
                width: v,
              });
            }}
          />
        </Space>
      </div>
    </div>
  );
}
